<template>
  <v-sheet class="pa-2 ma-2">
    <div class="tab-box-left">
      <v-tabs v-model="selectedTab" align-tabs="start" show-arrows>
        <v-tab key="pieChartKey" value="pieChartValue">
          Pie chart
        </v-tab>
        <v-tab key="tableKey" value="tableValue">
          Table
        </v-tab>
      </v-tabs>
      <v-window v-model="selectedTab">
        <v-window-item key="pieChartKey"
                       value="pieChartValue"
                       transition="fade-transition"
                       reverse-transition="fade-transition">
          <div class="pie-chart">
            <GChart type="PieChart"
                    @ready="chartReady"
                    :data="chartData"
                    :options="chartOptions"
                    :key="'demographicBaselineChart' + chartKeyIndex"
                    v-if="chartData.length !== 0"/>
            <v-progress-circular color="primary" indeterminate v-else></v-progress-circular>
          </div>
          <div class="label combined-pie-chart-and-table-comment">{{ chartComment }}</div>
        </v-window-item>
        <v-window-item key="tableKey"
                       value="tableValue"
                       transition="fade-transition"
                       reverse-transition="fade-transition">
          <div class="table-left">
            <transition name="fade" mode="out-in">
              <div :key="tableData">
                <v-data-table :headers="tableHeaders"
                              :items="tableData"
                              density="compact"
                              :fixed-header="true"
                              height="200px"
                              :items-per-page="0">
                  <template #bottom></template>
                  <template v-slot:[`item.percentage`]="{ item }">
                    <span style="color:#b2df8a">{{ item.percentage }}%</span>
                  </template>
                  <template v-slot:no-data>
                    <v-progress-circular color="primary" indeterminate></v-progress-circular>
                  </template>
                </v-data-table>
              </div>
            </transition>
          </div>
          <div class="label combined-pie-chart-and-table-comment">{{ tableComment }}</div>
        </v-window-item>
      </v-window>
    </div>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import {GChart} from "vue-google-charts";

export default defineComponent({
  name: 'CombinedPieChartAndTable',
  props: {
    chartData: Array,
    chartComment: String,
    tableHeaders: Array,
    tableData: Array,
    tableComment: String,
    visible: Boolean
  },
  components: {
    GChart
  },
  data: () => ({
    selectedTab: 'pieChartValue',
    chartKeyIndex: 0,
    chartOptions: {
      title: '',
      pieSliceText: 'value',
      is3D: false,
      backgroundColor: {
        fill: '#364c5b'
      },
      height: 250,
      colors: ['#a6cee3', '#06a0f3', '#b2df8a', '#67dd00', '#fb9a99', '#fdbf6f', '#cab2d6', '#ffff99'],
      titleTextStyle: {
        fontSize: 16,
        color: '#ffffff',
        bold: true
      },
      legend: {
        position: 'top',
        alignment: 'end',
        maxLines: 5,
        textStyle: {
          color: '#c0c0c0',
          fontSize: 12
        },
        scrollArrows: {
          activeColor: '#f0f0f0',
          inactiveColor: 'c0c0c0'
        },
        pagingTextStyle: {
          color: '#f0f0f0'
        }
      },
      tooltip: {
        isHtml: true
      }
    }
  }),
  methods: {
    forceRerender() {
      this.selectedTab = 'pieChartValue'
      this.chartKeyIndex += 1;
    },
    async chartReady(chart, google) {
      const setChartSelection = (selectedRow) => {
        let selectedRowData = this.chartData[selectedRow + 1]
        if (selectedRowData === undefined) {
          return
        }
        if (selectedRowData.length < 4) {
          return
        }
        let selectedItem = JSON.parse(this.chartData[selectedRow + 1][3])
        if (selectedItem !== undefined) {
          this.$emit('itemSelected', selectedItem)
        }
      }

      const selectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          return
        }
        const selectedItem = selection[0];
        setChartSelection(selectedItem.row)
      }

      google.visualization.events.addListener(chart, 'select', selectHandler);
    }
  },
  updated() {
    if (this.visible) {
      this.forceRerender()
    }
  }
});
</script>

<style scoped>
.tab-box-left {
  height: 375px;
  text-align: left;
  margin: 10px;
  border-radius: 8px;
  background-color: #364c5b;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 0 0 2px #c0c0c0; /* Elevated border effect */
}

.table-left {
  justify-content: space-around;
  text-align: left;
  padding: 20px;
}

.pie-chart {
  text-align: center;
}

.combined-pie-chart-and-table-comment {
  font-size: 0.8em;
  margin-top: 10px;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
